import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { handleRequestError } from "utils/Request";

export type InstabilityAlertSettings = {
  instability_alert_enabled: boolean;
  instability_alert_body: string | null;
};

async function fetchInstabilityAlert(): Promise<InstabilityAlertSettings> {
  const { data } = await api.get('/instability-alert');
  return data;
}

export function useInstabilityAlert() {
  const query = useQuery('instability-alert', fetchInstabilityAlert);

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Erro ao carregar alerta de instabilidade. Tente novamente.');
  }, [query.isError, query.error]);

  return query;
}
